import { IEnv } from '../features/whitelabeling/branding/types';

export const appSupportsInTourNarrations = (env: IEnv) =>
  !(env.features.inTourNarrations === false);
